import { extractIntegrationConfigurations, INTEGRATION_CONTACTS } from './integrationConfigurationUtils';
import { OdooConfig, OdooLogin } from './integrationTypes';

export const INTEGRATION_LOGIN_ODOO: OdooLogin = {
  DATABASE: { name: 'database', defaultValue: '' },
  USERNAME: { name: 'username', defaultValue: '' },
  API_KEY: { name: 'api_key', defaultValue: '' },
};

export const INTEGRATION_CONFIG_ODOO: OdooConfig = {
  CONTACTS: { name: INTEGRATION_CONTACTS, defaultValue: 'true' },
};

export const odooDefaultConfigurations = {
  ...extractIntegrationConfigurations(INTEGRATION_LOGIN_ODOO),
  ...extractIntegrationConfigurations(INTEGRATION_CONFIG_ODOO),
};
